<template>
  <div>
    <portal-target name="scuPortal"></portal-target>
    <!-- ************************************************** -->
    <div v-if="subPage === 0"> <!-- CU List Page -->
      <div :style="{ fontSize: fonts.font20 + 'px' }">
        Please select a CU from List
      </div>
      <b-button-group id="buttonGroup">
        <b-button id="btnAdd"
                  @click="addCU">
          Add CU
        </b-button>
      </b-button-group>
    </div>
    <!-- ************************************************** -->
    <div class="box" v-if="subPage === 1"> <!-- Add CU Page -->
      <div :style="{ fontSize: fonts.font20 + 'px' }">
        <h1>Add CU</h1>
      </div>
      <div>
        Enter 5 digit CU Number or 10 digit CUID
      </div>
      <b-form-input
        :name="rndName"
        ref="cuEnter1"
        v-model="addCun"
        class="bg4Inp"
        autocomplete="nope"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
      >
      </b-form-input>
      <b-button-group class="buttonGroup4Add">
        <b-button class="bg4Sub"
                  @click="addSubmit">
          Accept
        </b-button>
        <b-button class="bg4Can"
                  @click="addCancel">
          Cancel
        </b-button>
      </b-button-group>
    </div>
    <!-- ************************************************** -->
    <!-- There is no page #2 - Used to be DEL, but I merged it on cu Line -->
    <!-- ************************************************** -->
    <div class="box" v-if="subPage === 3"> <!-- Activate CU Page -->
      <div :style="{ fontSize: fonts.font20 + 'px' }">
        <h1>Activate Program</h1>
      </div>
      <div>
        Enter 5 digit CU Number or 10 digit CUID
      </div>
      <b-form-input
        :name="rndName"
        ref="cuEnter3"
        v-model="addCun"
        class="bg4Inp"
        autocomplete="nope"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false"
      >
      </b-form-input>
      <b-button-group class="buttonGroup4Add">
        <b-button class="bg4Sub"
                  @click="addSubmit">
          Activate
        </b-button>
      </b-button-group>
    </div>
    <!-- ************************************************** -->
    <div>
      <div v-for="cu in cuList" :key="cu.key">
        <div>
          <div>
            <div class="groupSection"
                 @mouseenter="mouseEnter(cu)"
                 @mouseleave="mouseExit(cu)">
              <div class="cuLine">
                <div class="cuDesc"
                     @click="clickedCU(cu)"
                     v-html="cu.desc"></div>
                <b-button class="bg4Del"
                     @click="delSubmit(cu)">
                     Remove
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <portal to="scuPortal">
      <!-- Don't show the "Back" button if subPage=3 (activate program) -->
      <button v-if="this.subPage < 3" @click="goBack" class="bButt"
              :style="{ fontSize: fonts.font12 + 'px' }">
        Back
      </button>
    </portal>
  </div>
</template>

<script>
export default {
  name: 'selectCU',
  data() {
    return {
      addCun: '',
      rndName: '',
      mySub: 0,
    };
  },
  watch: {
    myTenthSecond() {
      this.intervalTenthSecond();
    },
    cuListChangeCount() {
      this.cuListChanged();
    },
  },
  computed: {
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    cuList() {
      return this.$store.getters.getCuList;
    },
    cuListChangeCount() {
      return this.$store.getters.getCuListChangeCount;
    },
    subPage() {
      return this.$store.getters.cuListSubPage;
    },
    myTenthSecond() {
      return this.$store.getters.getMyTenth;
    },
  },
  methods: {
    cuListChanged() {
      this.$store.commit('setCuListSubPage', 0);
      this.writeDiag('cuListChanged');
      this.$forceUpdate();
      if (typeof this.cuList[this.cun] === 'undefined') {
        this.writeDiag(`Deleted ${this.cun}`);
        const keys = Object.keys(this.cuList);
        if (keys.length > 0) {
          const cu = this.cuList[keys[0]];
          this.writeDiag(`Select New CU=${cu.key}`);
          this.clickedCU(cu);
        } else {
          this.writeDiag('User removed last CU from list');
          // 'Please enter CU # to activate program'
          this.$store.commit('setCuName', 'Please enter CU # to activate program');
          const cun = '10101'; // Temp
          this.$store.dispatch('setCuNumber', cun);
          this.$store.commit('setCuListSubPage', 3);
        }
      }
    },
    clickedCU(cu) {
      this.writeDiag(`Clicked CU: ${cu.key}`);
      const cun = parseInt(cu.key.substr(0, 5), 10);
      this.writeDiag(`Selected CU: ${cun}`);
      if (this.subPage === 0) {
        this.$store.commit('selectCuFromList', cun);
      }
    },
    validateInput(cuInput) {
      if ((cuInput.length === 5) || (cuInput.length === 10)) {
        const cun = parseInt(cuInput.substr(0, 5), 10);
        if ((cun < 13000) || (cun > 65535)) {
          this.showAlert(`Invalid CU# or CUID: ${cuInput}`);
          return 1;
        }
        this.clearAlert();
        return cun;
      }
      this.showAlert('Input must be 5 or 10 digits');
      return 2;
    },
    addSubmit() {
      const addCun = this.addCun.trim();
      const cun = this.validateInput(addCun);
      if (cun > 12999) {
        this.$store.commit('setSpecifiedCUID', addCun); // This must be the FULL input
        const cuInfo = {};
        cuInfo.tryCun = cun;
        this.wsSend('c4VerifyCuNum', cuInfo); // Request CU Name - Will Auto-connect
      }
    },
    addCancel() {
      this.$store.commit('setCuListSubPage', 0);
      //
    },
    delSubmit(key) {
      const cun = parseInt(key.desc.substr(0, 5), 10);
      this.writeDiag(`delSubmit: cun='${cun}'`);
      if ((cun > 12999) && (cun < 65536)) {
        this.$store.commit('removeCuFromList', cun);
      }
    },
    addCU() {
      const myDate = +new Date();
      this.rndName = `add${myDate}`;
      this.writeDiag(`Clicked Add CU: name='${this.rndName}'`);
      this.$store.commit('setCuListSubPage', 1);
      //
    },
    // eslint-disable-next-line
    mouseEnter(cu) {
      // this.writeDiag(`mouseEnter CU: ${cu.key}`);
      //
    },
    // eslint-disable-next-line
    mouseExit(cu) {
      // this.writeDiag(`mouseExit CU: ${cu.key}`);
      //
    },
    writeDiag(message) {
      this.$store.commit('putDiag', `selCU: ${message}`);
    },
    showAlert(message) {
      this.$store.commit('setAlertMessage', message);
    },
    clearAlert() {
      this.$store.commit('clrAlertMessage');
    },
    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      // data.ver = this.binVer;
      this.$store.commit('sendObjToServer', data);
    },
    intervalTenthSecond() {
      if ((this.subPage === 0) && (this.cun === 0)) {
        const myDate = +new Date();
        this.rndName = `act${myDate}`;
        this.writeDiag(`CUN=0 forced activation window: name='${this.rndName}'`);
        this.$store.commit('setCuListSubPage', 3);
        this.mySub = 0;
      } else {
        // eslint-disable-next-line
        if (this.subPage !== this.mySub) {
          this.mySub = this.subPage;
          if (this.subPage === 1) {
            this.$refs.cuEnter1.$el.focus();
          }
          if (this.subPage === 3) {
            this.$refs.cuEnter3.$el.focus();
          }
        }
      }
    },
    goBack() {
      if (this.subPage === 0) {
        window.history.back();
      }
      if ((this.subPage === 1) || (this.subPage === 2)) {
        this.$store.commit('setCuListSubPage', 0);
      }
    },
  },
};

</script>

<style scoped>
  #buttonGroup {
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
    bottom: 0px;
    right: 0px;
    /* border: solid 1px red; */
    /* width: 50%; */
  }
  #btnAdd {
    background-color: lime;
    color: black;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
    /* width: 150px; */
    /* left: -10px; */
  }
  #btnDel {
    background-color: red;
    color: black;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
    /* width: 100px; */
    /* right: -10px; */
  }
  .buttonGroup4Add {
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
    bottom: 0px;
    right: 0px;
    /* border: solid 1px red; */
    /* width: 50%; */
  }
  .box {
    /* border: solid 1px red; */
  }
  .bg4Inp {
    margin: auto;
    width: 200px;
  }
  .bg4Sub {
    background-color: lime;
    color: black;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
  }
  .bg4Can {
    background-color: red;
    color: black;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
  }

  #buttonGroup4Del {
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
    bottom: 0px;
    right: 0px;
    /* border: solid 1px red; */
    /* width: 50%; */
  }

  .cuLine {
    width: 330px;
    display: flex;
    text-wrap: avoid;
    text-align: left;
    /* vertical-align: middle;*/
    margin: auto;
    padding: 0px 0px 0px 8px;
    height: 40px;
    background-color: transparent;
    font-weight: bold;
    border: solid 2px black;
    cursor: pointer;
  }
  .cuDesc {
    font-size: 12px;
    width: 80%;
    text-wrap: avoid;
    padding-top: 6px;
  }
  .bg4Del { /* Delete button on each CU Line */
    font-size: 12px;
    background-color: red;
    margin: auto;
    color: black;
  }
  .bButt { /* Back Button - Top left */
    position: absolute;
    top: 0px;
    left: 0px;
    background-color: red;
    color: black;
  }

</style>



// WEBPACK FOOTER //
// src/components/selectCU.vue